import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import { ndsFontReset } from '@nicollet/common';

const FLOAT_FORMAT = '[0-9]*\\.?[0-9]+';
const ratioFormat = new RegExp(`${FLOAT_FORMAT}x${FLOAT_FORMAT}`);

const isValidRatio = r => r && ratioFormat.test(r);

const containerStyles = (noDimensions, isRatioValid, fixedWidth, fixedHeight, display) => {
  if (noDimensions) return {};
  const STYLES = {
    display: display !== null && display !== void 0 ? display : 'inline-block'
  };

  if (typeof fixedWidth === 'string') {
    STYLES.width = fixedWidth;
  }

  if (typeof fixedHeight === 'string' && !(isRatioValid && fixedWidth)) {
    STYLES.height = fixedHeight;
  }

  return STYLES;
};

const AspectRatioContainer = styled.div`
  ${ndsFontReset({
  verticalAlign: 'bottom'
})}
  position: relative;
  height: 100%;
`;
const AspectRatioChildren = styled.div`
  ${({
  positionAbsolute,
  isRatioValid
}) => positionAbsolute && isRatioValid ? `
      position: absolute;
    ` : ''}
  ${({
  isRatioValid
}) => isRatioValid ? `
      top: 0;
      left: 0;
    ` : ''}
  ${({
  isRatioValid,
  hasWidth
}) => isRatioValid || hasWidth ? 'width: 100%;' : ''}
  ${({
  isRatioValid,
  hasHeight
}) => isRatioValid || hasHeight ? 'height: 100%;' : ''}
`;
const AspectRatioCanvas = styled.canvas`
  ${({
  hasWidth,
  hasHeight
}) => {
  if (hasWidth) {
    return 'width: 100%;';
  }

  if (hasHeight) {
    return 'height: 100%;';
  }

  return 'width: 100%;';
}}

  display: block;
  visibility: hidden;
`;

const AspectRatio = ({
  ratio,
  children,
  className,
  display,
  width,
  height,
  'data-test': testId,
  childrenPositionAbsolute = true
}) => {
  const hasWidth = !!width;
  const hasHeight = !!height;
  const noDimensions = !hasWidth && !hasHeight;
  const [isRatioValid, ratioWidth, ratioHeight] = isValidRatio(ratio) && ratio ? [true, ...ratio.split('x')] : [false, undefined, undefined];
  return jsxs(AspectRatioContainer, Object.assign({
    className: className,
    "data-test": testId,
    style: containerStyles(noDimensions, isRatioValid, width, height, display)
  }, {
    children: [jsx(AspectRatioChildren, Object.assign({
      hasHeight: hasHeight,
      hasWidth: hasWidth,
      isRatioValid: isRatioValid,
      positionAbsolute: childrenPositionAbsolute
    }, {
      children: children
    }), void 0), isRatioValid && jsx(AspectRatioCanvas, {
      "aria-hidden": true,
      hasHeight: hasHeight,
      hasWidth: hasWidth,
      height: ratioHeight,
      width: ratioWidth
    }, void 0)]
  }), void 0);
};

AspectRatio.displayName = 'AspectRatio';

export { AspectRatio };
